import React from "react";
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import styles from "../styles/dashboard.css";
import AddProduct from "./AddProduct";
import logo from "../images/nav-logo.png"
import ManageRep from "./ManageRep";
import DashRepSelect from "./DashRepSelect";
import Hollydays from "./Hollydays";
import ManageInvoices from "./ManageInvoices";
import ManageInventory from './ManageInventory';
import InventoryChart from './InventoryChart';

const Dashboard = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  
  useEffect(() => {
    // Get user from session storage
    const userData = sessionStorage.getItem('user');
    
    if (userData) {
      setUser(JSON.parse(userData));
    } else {
      // If no user data found, redirect to login
      navigate('/Login');
    }
  }, [navigate]);

  const handleLogout = () => {
    // Clear the auth token cookie
    document.cookie = 'auth_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    
    // Clear user data from session storage
    sessionStorage.removeItem('user');
    
    // Redirect to login page
    navigate('/Login');
  };

  const allTabs = [
    {
      id: "tab1",
      label: "Manage Product",
      component: () => <AddProduct />,
      roles: ["admin", "storekeeper"],
      tabIcon: "fa-solid fa-prescription-bottle"
    },
    {
      id: "tab2",
      label: "Manage representative",
      component: () => <ManageRep/>,
      roles: ["admin"],
      tabIcon: "fa-solid fa-user-group"
    },
    {
      id: "tab3",
      label: "Inventory",
      component: () => <ManageInventory/>,
      roles: ["admin", "storekeeper"],
      tabIcon: "fa-solid fa-boxes-stacked"
    },
    {
      id: "tab4",
      label: "Rep Profiles",
      component: () => <DashRepSelect/>,
      roles: ["admin"],
      tabIcon: "fa-solid fa-user-group"
    },
    {
      id: "tab5",
      label: "Add Invoice",
      component: () => <ManageInvoices/>,
      roles: ["admin", "accountant"],
      tabIcon: "fa-solid fa-user-group"
    },
    {
      id: "tab6",
      label: "Hollydays",
      component: () => <Hollydays/>,
      roles: ["admin"],
      tabIcon: "fa-solid fa-user-group"
    },
    {
      id: "tab7",
      label: "Inventory View",
      component: () => <InventoryChart/>,
      roles: ["admin", "storekeeper", "accountant"],
      tabIcon: "fa-solid fa-boxes-stacked"
    },
  ];
  
  // Filter tabs based on user role
  const filteredTabs = user ? 
    allTabs.filter(tab => tab.roles.includes(user.role)) : 
    [];
  
  const [activeTab, setActiveTab] = useState("");
  
  // Set the first available tab as active when tabs are filtered or user changes
  useEffect(() => {
    if (filteredTabs.length > 0 && (!activeTab || !filteredTabs.some(tab => tab.id === activeTab))) {
      setActiveTab(filteredTabs[0].id);
    }
  }, [filteredTabs, activeTab]);

  const ActiveComponent =
    filteredTabs.find((tab) => tab.id === activeTab)?.component || null;

  // If user not authenticated, show loading or nothing
  if (!user) {
    return <div className="text-center p-5">Loading...</div>;
  }
    
  return (
    <div className="container-fluid">
      <div className="row flex-nowrap">
        <div className="side-bar col-auto col-md-3 col-xl-2 px-sm-2 px-0 bg-light">
          <div className="mt-3 flex-column align-items-center align-items-sm-start px-3 pt-2 text-white min-vh-100">
            <a
              href="#"
              className="d-flex align-items-center pb-3 mb-md-0 me-md-auto text-white text-decoration-none"
            ><Link to="/">
            <a className="sidenav-logo-pic">
              <img src={logo} alt="" srcSet="" />
            </a>
          </Link>
              
            </a>
            <ul
              className="nav nav-pills gap-2 flex-column mb-sm-auto mb-0 align-items-center align-items-sm-start"
              id="menu"
            >
              {filteredTabs.map((tab) => (
                <li
                  key={tab.id}
                  className={`nav-item ${activeTab === tab.id ? "active" : ""}`}
                  onClick={() => setActiveTab(tab.id)}
                >
                  <a className="nav-link align-middle">
                    <i className={tab.tabIcon}></i>
                    <span className="ms-1 d-none d-sm-inline">{tab.label}</span>
                  </a>
                </li>
              ))}
              <li className="nav-item logout-item">
                <button 
                  className="btn btn-outline-danger nav-link" 
                  onClick={handleLogout}
                  style={{border: '1px solid #5D7285', width: '100%', textAlign: 'left'}}
                >
                  <svg 
                    width="22" 
                    height="22" 
                    viewBox="0 0 24 24" 
                    xmlns="http://www.w3.org/2000/svg"
                    style={{fill: '#5D7285'}}
                  >
                    <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"/>
                  </svg>
                  <span className="ms-1 d-none d-sm-inline">Logout</span>
                </button>
              </li>
            </ul>
          </div>
        </div>
        <div className="col clubs-page-content page-content">
          <div className="user-welcome p-3">
            <h4>Welcome, {user.name || 'User'}</h4>
            <p>Role: <span className="text-capitalize">{user.role || 'N/A'}</span></p>
          </div>
          {ActiveComponent && <ActiveComponent />}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
